import { render, staticRenderFns } from "./TrashRender.vue?vue&type=template&id=5feeb9d0&functional=true"
import script from "./TrashRender.vue?vue&type=script&lang=js"
export * from "./TrashRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports